import { postponingEnabled } from '@/constants/orders'
import TerminalAPI from '@/features/api/terminal/terminal'
import ConstructiveButton from '@/features/common/buttons/ConstructiveButton'
import { logger } from '@/features/orders/logger'
import Button from '@/features/ui/buttons/components/Button'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface AcceptedOrderDetailFooterActionButtonsProps {
    orderUuid: string
    postponeDisabled: boolean
    onPostponeButton: () => void
}

const AcceptedOrderDetailFooterActionButtons: FC<AcceptedOrderDetailFooterActionButtonsProps> = ({
    orderUuid,
    postponeDisabled,
    onPostponeButton,
}) => {
    const [startOrderProductionLoading, setStartOrderProduction] = useState(false)

    const { t } = useTranslation()

    const handleError = useHandleErrorWithToast(logger)

    const handleStartProductionButton = async () => {
        try {
            setStartOrderProduction(true)

            await TerminalAPI.startOrderProduction(orderUuid)
        } catch (e) {
            handleError(e)
        } finally {
            setStartOrderProduction(false)
        }
    }

    return (
        <View style={styles.container}>
            {postponingEnabled && (
                <Button
                    disabled={postponeDisabled || startOrderProductionLoading}
                    type="outline"
                    color="secondary"
                    onPress={onPostponeButton}
                    style={styles.actionButton}
                >
                    {t('order.detail.postpone')}
                </Button>
            )}
            <ConstructiveButton
                disabled={startOrderProductionLoading}
                onPress={handleStartProductionButton}
                style={styles.actionButton}
            >
                {t('order.detail.toProduction')}
            </ConstructiveButton>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 16,
        flexGrow: 1,
        flexShrink: 1,
    },
    actionButton: {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: '50%',
        justifyContent: 'center',
        height: 44,
        maxWidth: 164,
    },
})

export default AcceptedOrderDetailFooterActionButtons
